import React from 'react';
import { cn } from '@/lib/utils';

interface UserIconProps {
  className?: string;
  size?: number | string;
  color?: string;
}

const UserIcon: React.FC<UserIconProps> = ({
                                             className = '',
                                             size = 24,
                                             color,
                                           }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="41 41 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(color, className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.507 41.0018C49.4939 41.0013 49.4778 41.0009 49.4588 41.0005C49.4163 40.9998 49.3593 40.9996 49.2898 41.0014C49.151 41.005 48.9602 41.0164 48.7341 41.0468C48.2866 41.107 47.674 41.2453 47.0496 41.5666C46.4176 41.8918 45.7725 42.4058 45.2911 43.2026C44.8101 43.9986 44.5287 45.0167 44.5287 46.2941C44.5287 48.1647 45.681 49.6188 46.6963 50.5495L46.6967 50.5499C46.8834 50.7209 47.0739 50.8841 47.2687 51.0394C46.5676 51.3139 45.6633 51.6831 44.7703 52.0478C44.5767 52.1268 44.3837 52.2056 44.1933 52.2833C42.2848 53.0614 41 54.9201 41 57H43C43 55.7519 43.7751 54.6136 44.9484 54.1352C45.1391 54.0575 45.3304 53.9794 45.5206 53.9017C46.9147 53.3326 48.2494 52.7878 48.8359 52.5873C49.0456 52.5155 49.2533 52.4371 49.4583 52.3519C49.6587 52.4368 49.8639 52.5153 50.0743 52.5873C50.6827 52.7953 52.1154 53.3701 53.5787 53.9573C53.7368 54.0207 53.8952 54.0842 54.053 54.1475C55.2252 54.6175 56 55.7517 56 57H58C58 54.9199 56.7144 53.0598 54.7973 52.2912C54.6343 52.2258 54.4694 52.1596 54.3038 52.0932C53.3777 51.7215 52.4315 51.3418 51.6987 51.0583C51.9065 50.898 52.1082 50.7285 52.3033 50.5499L52.3034 50.5498C53.3202 49.6185 54.4713 48.1645 54.4713 46.2941C54.4713 44.9255 54.0806 43.6027 53.2228 42.6054C52.3516 41.5925 51.0755 41.007 49.507 41.0018ZM49.4733 50.13C50.0067 49.8379 50.5041 49.4856 50.9526 49.0749C51.8249 48.276 52.4713 47.3207 52.4713 46.2941C52.4713 45.2882 52.1841 44.4649 51.7065 43.9096C51.2463 43.3745 50.5372 43.0017 49.4856 43.0017H49.4579L49.4361 43.0005L49.4236 43.0002C49.4081 42.9999 49.3801 42.9998 49.3415 43.0008C49.2638 43.0028 49.1455 43.0095 49.0006 43.029C48.7062 43.0685 48.3295 43.1572 47.9647 43.345C47.6074 43.5288 47.2633 43.8059 47.0028 44.2369C46.7419 44.6688 46.5287 45.3152 46.5287 46.2941C46.5287 47.3204 47.1755 48.2756 48.0474 49.0749M49.4733 50.13C48.972 49.8419 48.5021 49.4913 48.0475 49.075L49.4733 50.13Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UserIcon;
